<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("vouchersPage.tabPending") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <MarketingPendingVouchers v-if="active === 0" />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("vouchersPage.tabExpired") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <MarketingExpiredVouchers v-if="active === 1" />
        </div>
      </v-tab-item>
    </v-tabs>


  </div>
</template>

<script>

import MarketingExpiredVouchers from "@/views/vouchers/marketing_vouchers/MarketingExpiredVouchers";
import MarketingPendingVouchers from "@/views/vouchers/marketing_vouchers/MarketingPendingVouchers";

export default {
  name: "MarketingVouchers",
  title() {
    return this.$t("vouchersPage.pageTitleMarketing");
  },
  components: {
    MarketingPendingVouchers,
    MarketingExpiredVouchers
  },
  data() {
    return {
      active: 0,
    };
  },

};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
